import React from "react";
import Header from "../../Pages/Header";
import Footer from "../../Pages/Footer";
import ScrollToTop from "./ScrollToTop";
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaPhoneAlt,
} from "react-icons/fa";

const Layout = ({ children }) => {
  return (
    <>
      <div className="top-container">
        <div className="w-75 h-100 d-flex justify-content-between align-items-center m-auto">
          <div className="contact text-white">
            <FaPhoneAlt className="phone" />
            &nbsp;
            <a href="tel:01-4500066">01-4500066</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="mailto:educrafteducationnetwork@gmail.com">
              <FaEnvelope />
              &nbsp; educrafteducationnetwork@gmail.com
            </a>
          </div>
          <div className="social-medias d-flex justify-content-center align-items-center gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=100088829740129"
              target="_blank"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/educrafteducation?igsh=c296Z2k0dzVtZHNv"
              target="_blank"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@educraft.education"
              target="_blank"
            >
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>
      <div className="main-container">
        <Header />
        {children}
        <Footer />
      </div>
      <ScrollToTop />
    </>
  );
};

export default Layout;
